document.addEventListener('DOMContentLoaded', function () {
  const searchInput = document.querySelector('#faculty-directory .faculty-search');
  const departmentSelect = document.querySelector('#faculty-directory .faculty-filter');
  const list = document.querySelector('#faculty-list');
  const pagination = document.querySelector('.faculty-pagination');
  const clearLink = document.querySelector('.faculty-clear');

  const allItems = Array.from(list.querySelectorAll('li'));
  const itemsPerPage = 10;
  let currentPage = 1;

  function normalize(str) {
    return str.toLowerCase().trim();
  }

  function filterItems() {
    const search = normalize(searchInput.value);
    const dept = normalize(departmentSelect.value);
    return allItems.filter(item => {
      const name = normalize(item.querySelector('.faculty-listing-heading').textContent);
      const contact = normalize(item.querySelector('.faculty-listing-contact').textContent);
      return name.includes(search) && (dept === '' || contact.includes(dept));
    });
  }

  function paginate(items, page = 1) {
    const start = (page - 1) * itemsPerPage;
    return items.slice(start, start + itemsPerPage);
  }

  function updateList() {
    const filtered = filterItems();
    const paged = paginate(filtered, currentPage);
    allItems.forEach(item => {
      item.style.display = 'none';
      item.classList.remove('has-top-border');
    });
    paged.forEach((item, index) => {
      item.style.display = '';
      if (index === 0) item.classList.add('has-top-border');
    });
    updatePagination(filtered.length);
  }

  function updatePagination(totalItems) {
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    pagination.innerHTML = '';

    const maxVisiblePages = window.innerWidth >= 768 ? 5 : 3;

    const addPageItem = (page, isActive = false) => {
      const li = document.createElement('li');
      li.className = 'page-item' + (isActive ? ' active' : '');
      const a = document.createElement('a');
      a.href = '#';
      a.className = 'page-link';
      a.textContent = page;
      a.setAttribute('aria-label', `Page ${page}`);
      if (isActive) a.setAttribute('aria-current', 'page');
      a.addEventListener('click', (e) => {
        e.preventDefault();
        currentPage = page;
        updateList();
      });
      li.appendChild(a);
      pagination.appendChild(li);
    };

    const addEllipsis = () => {
      const li = document.createElement('li');
      li.className = 'page-item';
      const span = document.createElement('span');
      span.className = 'page-link';
      span.textContent = '...';
      li.appendChild(span);
      pagination.appendChild(li);
    };

    if (currentPage > 1) {
      const li = document.createElement('li');
      li.className = 'page-item prev';
      const a = document.createElement('a');
      a.href = '#';
      a.className = 'page-link';
      a.textContent = 'Previous';
      a.setAttribute('aria-label', 'Previous page');
      a.addEventListener('click', (e) => {
        e.preventDefault();
        currentPage--;
        updateList();
      });
      li.appendChild(a);
      pagination.appendChild(li);
    }

    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        addPageItem(i, i === currentPage);
      }
    } else {
      if (window.innerWidth < 768) {
        addPageItem(1, currentPage === 1);
        if (currentPage > 2 && currentPage < totalPages - 1) addEllipsis();
        if (currentPage !== 1 && currentPage !== totalPages) addPageItem(currentPage, true);
        if (currentPage < totalPages - 1) addEllipsis();
        addPageItem(totalPages, currentPage === totalPages);
      } else {
        const sidePages = Math.floor(maxVisiblePages / 2);
        let start = Math.max(1, currentPage - sidePages);
        let end = Math.min(totalPages, currentPage + sidePages);

        if (start > 1) {
          addPageItem(1);
          if (start > 2) addEllipsis();
        }

        for (let i = start; i <= end; i++) {
          addPageItem(i, i === currentPage);
        }

        if (end < totalPages) {
          if (end < totalPages - 1) addEllipsis();
          addPageItem(totalPages);
        }
      }
    }

    if (currentPage < totalPages) {
      const li = document.createElement('li');
      li.className = 'page-item next';
      const a = document.createElement('a');
      a.href = '#';
      a.className = 'page-link';
      a.textContent = 'Next';
      a.setAttribute('aria-label', 'Next page');
      a.addEventListener('click', (e) => {
        e.preventDefault();
        currentPage++;
        updateList();
      });
      li.appendChild(a);
      pagination.appendChild(li);
    }
  }

  if (clearLink) {
    clearLink.addEventListener('click', (e) => {
      e.preventDefault();
      searchInput.value = '';
      departmentSelect.value = '';
      currentPage = 1;
      updateList();
      searchInput.focus();
    });
  }

  searchInput.addEventListener('input', () => {
    currentPage = 1;
    updateList();
  });

  departmentSelect.addEventListener('change', () => {
    currentPage = 1;
    updateList();
  });

  updateList();
});